import React, { Component } from 'react'
import Joyride from 'react-joyride'
import { observer, inject } from 'mobx-react'
import steps from 'tour.js'
import { selectionTypes } from 'constants.js'
import { withTranslation } from 'react-i18next'

@inject('uiStore', 'selectionStore', 'dataStore') @observer
class Tour extends Component {
  tourRef = React.createRef()

  callback ({ action, type, status, index }) {
    const addButton = document.querySelector('.my-target-groups>.target-group>*>.add-button')
    if (action === 'next' && index === 1 && !addButton) {
      document.querySelector('.my-target-groups>.target-group>nav>.expand-collapse').click()
    }
    if (action === 'close' || (action === 'next' && status === 'finished')) {
      document.querySelector('.my-target-groups>.target-group>nav>.expand-collapse').click()
      // remove tour item
      this.props.uiStore.removeTourItem()
      // reset the tour when it is closed
      this.props.uiStore.runHelpTour = false
      this.tourRef.current.reset()
    } else if (
      action === 'start' && type === 'step:before'
    ) {
      // add tour item
      this.props.uiStore.addTourItemIfNeeded()
      // Make sure target groups are visible and "new item"
      // is selected before starting the tour
      this.props.uiStore.myTargetGroupsExpanded = true
      this.props.selectionStore.set({
        type: selectionTypes.NEW_ITEM,
        data: { group: this.props.dataStore.myTargetGroups[0] }
      })
    } else if (
      action === 'next' &&
      type === 'step:after' &&
      (index === (this.props.uiStore.user.canShare ? 12 : 11))
    ) {
      // choose tour item
      this.props.uiStore.selectTourItem()
    }
  }

  render () {
    const TOUR_LOCALE = {
      back: this.props.t('TOUR_LOCALE.BACK'),
      close: this.props.t('TOUR_LOCALE.CLOSE'),
      last: this.props.t('TOUR_LOCALE.LAST'),
      next: this.props.t('TOUR_LOCALE.NEXT'),
      skip: this.props.t('TOUR_LOCALE.SKIP')
    }

    return (
      <Joyride
        ref={this.tourRef}
        steps={steps(this.props.uiStore.user)}
        run={this.props.uiStore.runHelpTour}
        locale={TOUR_LOCALE}
        continuous
        showProgress
        disableOverlay
        spotlightPadding={10}
        callback={(info) => this.callback(info)}
      />
    )
  }
}

export default withTranslation()(Tour)
